const GameState = {
	uninitialized: -1,
	playing: 0,
	playingGuess: 0.5,
	done: 1,
	results: 2,
};

document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	currentStepIndex: 0,
	steps: [
		{
			title: 'Vertical',
			questions: [0, 1, 2],
			ref: `1. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22.<br />
2. Fouquet, B., & Jaume-Guichard, P. (2021). Activités physiques, sédentarité, comorbidités et arthrose. Revue du Rhumatisme Monographies, 88(3), 194-202`
		},
		{
			title: 'Horizontal <span>(1/2)</span>',
			questions: [3, 4, 5],
			ref: `1. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22.<br />
2. Fouquet, B., & Jaume-Guichard, P. (2021). Activités physiques, sédentarité, comorbidités et arthrose. Revue du Rhumatisme Monographies, 88(3), 194-202.<br />
3. Ameli (2021). Arthrose du genou : définition et facteurs favorisants. [en ligne] https://www.ameli.fr/assure/sante/themes/arthrose-genou/definition-facteurs-favorisants - consulté le 02.12.2022`
		},
		{
			title: 'Horizontal <span>(2/2)</span>',
			questions: [6, 7],
			ref: `1. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22.<br />
4. Millán, Marta Martín, and Santos Castañeda. (2013) "Estrogènes, arthrose et inflammation." Revue du rhumatisme 80.4 : 350-356.`
		}
	],
	questions: [
		{ vertical: true, found: false, question: `Anomalie morphologique d'un organe ou d'une partie du corps<sup>1</sup>.`, answer: 'MALFORMATION' },
		{ vertical: true, found: false, question: `(adjectif) Qui est l’objet d’un effort très soutenu<sup>2</sup>.`, answer: 'INTENSIF' },
		{ vertical: true, found: false, question: `Transmission des caractères des parents à leurs descendants, relative aux gènes<sup>2</sup>.`, answer: 'GÉNÉTIQUE' },
		{ vertical: false, found: false, question: `Situation qui définit une activité physique faible ou nulle, sans dépense énergétique<sup>2</sup>.`, answer: 'SÉDENTARITÉ' },
		{ vertical: false, found: false, question: `Lésion des ligaments qui maintiennent une articulation, sans déplacement des structures internes<sup>1</sup>.`, answer: 'ENTORSE' },
		{ vertical: false, found: false, question: `Ensemble des phénomènes qui marquent l'évolution du vivant, relatifs à l’âge<sup>3</sup>.`, answer: 'VIEILLISSEMENT' },
		{ vertical: false, found: false, question: `Excès de poids par augmentation de la masse grasse<sup>1</sup>.`, answer: 'OBÉSITÉ' },
		{ vertical: false, found: false, question: `Interruption physiologique des cycles menstruels chez la femme et de la fonction ovarienne<sup>1,4</sup>.`, answer: 'MÉNOPAUSE' },
	],
	gridItems: [],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.renderPlayingState();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.playingGuess:
				document.getElementById('state-playing-guess').classList.remove('hidden');
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	generateGridItem() {
		const starts = {
			0: { row: 1, col: 12 },
			1: { row: 5, col: 19 },
			2: { row: 7, col: 7 },
			3: { row: 8, col: 6 },
			4: { row: 8, col: 19 },
			5: { row: 10, col: 11 },
			6: { row: 12, col: 3 },
			7: { row: 14, col: 1 },
		};
		this.gridItems = [];
		this.questions.forEach((question, index) => {
			let rowStart = starts[index].row;
			let colStart = starts[index].col;
			question.itemsIndex = []; // To find them by index
			question.answer.split('').forEach((letter, i) => {
				question.itemsIndex.push(this.gridItems.length);
				this.gridItems.push({
					letter,
					row: question.vertical ? rowStart + i : rowStart,
					col: question.vertical ? colStart : colStart + i,
				});
			});
		});
	},
	renderGrid() {
		let html = '';
		this.questions.forEach(question => {
			if (!question.found) { return; }
			question.itemsIndex.forEach(itemIndex => {
				const item = this.gridItems[itemIndex];
				html += `<div class="game-grid-item" style="grid-row: ${item.row}; grid-column: ${item.col}">${item.letter}</div>`;
			});
		});
		const grid = document.getElementById('game-grid');
		grid.innerHTML = html;
	},
	renderStep() {
		const currentStep = this.steps[this.currentStepIndex];

		// Set title
		const titleDiv = document.getElementById('step-title');
		titleDiv.innerHTML = currentStep.title;

		// Show questions
		let questionsHtml = "";
		currentStep.questions.forEach(index => {
			questionsHtml += `<div><label><span>${index + 1}</span>${this.questions[index].question}</label><br/>
<input type="text" data-question-id="${index}" /></div>`;
		});
		const questionDiv = document.getElementById('step-questions');
		questionDiv.innerHTML = questionsHtml;

		// Show first button
		const actionsDiv = document.getElementById('step-action');
		const buttons = actionsDiv.getElementsByTagName('button');
		for (let i = 0; i < buttons.length; i++) {
			const btn = buttons[i];
			if (i === 0) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}

		// Set ref
		const referenceDiv = document.getElementById('game-references');
		referenceDiv.innerHTML = `Références:<br/>${currentStep.ref}`;
	},
	renderPlayingState() {
		this.renderGrid();
		this.renderStep();
	},
	answer() {
		const questionDiv = document.getElementById('step-questions');
		const answersInputs = questionDiv.getElementsByTagName('input');

		let allFound = true;
		for (let i = 0; i < answersInputs.length; i++) {
			const input = answersInputs[i];
			const value = (input.value || "");
			const questionId = input.dataset.questionId;

			const answer = this.questions[questionId].answer;
			const isValid = value.trim().toLowerCase().replaceAll("é", "e").replaceAll("è", "e") === answer.toLowerCase().replaceAll("é", "e").replaceAll("è", "e");
			if (isValid) {
				this.questions[questionId].found = true;
				input.classList.add("found");
				input.readOnly = true;
				input.value = answer; // To add accent if the user didn't use them
			} else if (value.length) {
				const errorDiv = document.createElement('div')
				errorDiv.innerHTML = "Oups ! Mauvaise réponse";
				errorDiv.classList.add("error-message");
				input.after(errorDiv);
			}
			allFound = allFound && isValid;
		}
		this.renderGrid();
		if (allFound) {
			// Change button
			const actionsDiv = document.getElementById('step-action');
			const buttons = actionsDiv.getElementsByTagName('button');
			for (let i = 0; i < buttons.length; i++) {
				const btn = buttons[i];
				if (i === 1) {
					btn.classList.remove('hidden');
				} else {
					btn.classList.add('hidden');
				}
			}
		} else {
			setTimeout(() => {
				const errors = document.getElementsByClassName("error-message");
				while (errors.length) {
					const e = errors[0];
					e.parentNode.removeChild(e);
				}
			}, 2000);
		}
	},
	restart() {
		this.currentStepIndex = 0;
		this.questions.forEach(question => {
			question.found = false;
		});
		this.state = GameState.playing;
		this.generateGridItem();
		this.render();
	},
	next() {
		this.currentStepIndex += 1;
		if (this.currentStepIndex === this.steps.length) {
			this.state = GameState.playingGuess;
			this.render();
			return;
		}

		this.renderStep();
	},
	showGuessTip() {
		const existingTip = document.getElementById('tip-content');
		if (existingTip) return;

		const tipContainer = document.getElementById('game-tip-container');
		// tipLink.after()
		const tipDiv = document.createElement("div");
		tipDiv.innerHTML = `Essentiel à la prise en charge<br/>de l’arthrose, il contribue<br/>notamment à entretenir la force<br/>musculaire et à réduire la douleur<sup>5</sup>.`;
		tipDiv.setAttribute("id", "tip-content");
		tipContainer.appendChild(tipDiv);

		const refDiv = document.getElementById('game-guess-ref');
		refDiv.classList.remove('hidden');
	},
	guessWord() {
		const input = document.getElementById('guess-word');
		if (input.classList.contains('found')) {
			this.state = GameState.done;
			this.render();
			return;
		}

		if (input.value.trim().toLowerCase() !== 'mouvement') {
			const errorDiv = document.createElement('div')
			errorDiv.innerHTML = "Oups ! Mauvaise réponse";
			errorDiv.classList.add("error-message");
			input.after(errorDiv);
			setTimeout(() => {
				errorDiv.parentNode.removeChild(errorDiv);
			}, 2000);
			return;
		}
		this.showGuessTip();
		input.classList.add('found');
		input.readOnly = true;
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();

addEventListener('resize', document.computeSizes);
